import React, { useEffect, useState, useContext } from "react";
import db from "../../../api/mongodb";
import { useHistory, useNavigate, useLocation } from "react-router-dom";
import { Outlet } from "react-router";
import Lottie from "react-lottie";

import { defaultOptions1 } from "../../../config/loading-config.js";
import ProjectGrid from "./ProjectGrid";
import MainSideBar from "../../navigation/MainSidebar";
import "./Home.scss";
import Container from "react-bootstrap/Container";
import NavDropdown from "react-bootstrap/NavDropdown";
import ToggleIcon from "../../../images/toggle-icon.svg";
import MyAccountIcon from "../../../images/My-Account-icon.svg";
import LogoutIcon from "../../../images/Logout-icon.svg";
import DummyProfilePic from "../../../images/dummy-profile-picture.svg";
import { UserDispatchContext, UserContext } from "./../../../api/UserProvider";
import BugReportPopup from "../safeAPs/ui/BugReportPopup";

const Dashboard = ({ projectType }) => {
    const [safeAp, setSafeAp] = useState({});
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = new useState(projects);
    const [profileImg, setProfileImg] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();
    const details = useContext(UserContext);

    const safeApId =useContext(UserContext).id
    

    const userId = useContext(UserContext).id

    const location = useLocation();


    useEffect(() => {
        const apiCall = async () => {
            //   if (projectType == null) {
            //     return;
            //   }

            // var allProjects = [];
            // var response;

            // const userid = sessionStorage.getItem("id");
            var response = await db.get(`/api/safeAPs/${userId}`, {
                headers: { Authorization: `${localStorage.getItem("token")}` },
            });
            // console.log(response.data)
            setSafeAp(response.data);

            // if (sessionStorage.getItem("name") !== "Admin") {
            //   const userid = sessionStorage.getItem("id");
            //   var response = await db.get(`/api/safeAPs/${userid}`);
            //   setSafeAp(response.data);
            //   const primary = response.data.projects.primary;
            //   const secondary = response.data.projects.secondary;
            //   allProjects = primary.concat(secondary);

            //   var response = await db.put("/api/projects/find/multiple", {
            //     ids: allProjects,
            //   });
            // } else {
            //   var response = await db.get(`/api/projects/`);
            // }

            // setProjects(response.data);
            // setFilteredProjects(response.data);
            // setIsLoading(false);
        };
        if (userId) {
            apiCall();

        }
    }, [userId]);

    useEffect(() => {
        const apiCall = async () => {
            //   if (projectType == null) {
            //     return;
            //   }

            // var allProjects = [];
            // var response;

            // const userid = sessionStorage.getItem("id");
            var response = await db.get(`/api/safeAPs/${userId}`, {
                headers: { Authorization: `${localStorage.getItem("token")}` },
            });
            // console.log(response.data)
            setSafeAp(response.data);

            // if (sessionStorage.getItem("name") !== "Admin") {
            //   const userid = sessionStorage.getItem("id");
            //   var response = await db.get(`/api/safeAPs/${userid}`);
            //   setSafeAp(response.data);
            //   const primary = response.data.projects.primary;
            //   const secondary = response.data.projects.secondary;
            //   allProjects = primary.concat(secondary);

            //   var response = await db.put("/api/projects/find/multiple", {
            //     ids: allProjects,
            //   });
            // } else {
            //   var response = await db.get(`/api/projects/`);
            // }

            // setProjects(response.data);
            // setFilteredProjects(response.data);
            // setIsLoading(false);
        };
        if (userId) {
            apiCall();

        }
    }, [projectType, location]);

    // useEffect(() => {
    //   // new data
    // }, [projectType /*, location*/]);

    const profileFunc = () => {
        var url = "/safeAPs/profile/" + userId;
        // history.push(url);
        // history.go(0);
        navigate(url);
        navigate(0);
    };

    const accountFunc = () => {
        var url = "/safeAPs/account/" + userId;
        navigate(url);
        navigate(0);
    };

    const handleCloseModal = () => {
        setShowPopup(false)
    }

    const logoutFunc = () => {
        db.get("/api/safeAPs/logout")
            .then((response) => {
                sessionStorage.removeItem("id");
                sessionStorage.removeItem("name");
                sessionStorage.removeItem("role");
                localStorage.removeItem("token");
                // history.push("/");
                // history.go(0);
                navigate("/");
                navigate(0);
            })
            .catch((error) => { });
    };

    // if (isLoading) {
    //   return <Lottie options={defaultOptions1} height={200} width={200} />;
    // }

    return (
        <>
            <div className="dashboard">
                <MainSideBar adminView={false} projectType={projectType} />

                <Container fluid>
                    <div className="dashboard-app">
                        <header className="dashboard-toolbar">
                            {/* <a href="#!" className="menu-toggle">
                <img src={ToggleIcon} alt="Menu toggle icon" />
              </a>
              <div>{"Last Successful Login 25 Nov 2021 | 09:34 GMT+3"}</div> */}
                            {
                                safeAp.formData ?
                                    <NavDropdown
                                        title={
                                            <span>
                                                <img
                                                    src={
                                                        safeAp.formData.img && safeAp.formData.img.length
                                                            ? safeAp.formData.img[0].content
                                                            : DummyProfilePic
                                                    }
                                                    width="44"
                                                    height="44"
                                                    style={{
                                                        borderRadius: "50%",
                                                        border: "2px solid #85CFFA",
                                                    }}
                                                    alt="Profile picture"
                                                />
                                                &nbsp;
                                                {`${safeAp.formData.firstName} ${safeAp.formData.lastName}`}
                                            </span>
                                        }
                                        id="collasible-nav-dropdown"
                                        className="menu-profile-pic"
                                    >
                                        <NavDropdown.Item href="#action/3.1" onClick={profileFunc}>
                                            <img src={MyAccountIcon} alt="" />
                                            &nbsp;&nbsp;Profile
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.1" onClick={accountFunc}>
                                            <img src={MyAccountIcon} alt="" />
                                            &nbsp;&nbsp;My Account
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.2" onClick={logoutFunc}>
                                            <img src={LogoutIcon} alt="" />
                                            &nbsp;&nbsp;Logout
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="#action/3.2" onClick={() => { setShowPopup(true) }}>
                                            Report an Issue
                                        </NavDropdown.Item>
                                    </NavDropdown> :
                                    null
                            }


                        </header>

                        <div className="dashboard-content">
                            <Outlet
                                context={{
                                    projects,
                                    setProjects,
                                    filteredProjects,
                                    setFilteredProjects,
                                    projectType,
                                    safeAp,
                                    setSafeAp,
                                    safeApId,
                                    isLoading,
                                    setIsLoading,
                                }}
                            />
                        </div>
                    </div>
                </Container>
                <BugReportPopup showPopup={showPopup} handleCloseModal={handleCloseModal} />

            </div>
        </>
    );
};

export default Dashboard;
